import { sum, cloneDeep } from 'lodash';
import { checkArray } from '../../../../Components/helper';

const hasNumberValue = (element) => {
  return element && !isNaN(element) ? parseFloat(element) : 0;
};

export default function useGrandTotal() {
  const calculateGrandTotal = async (data) => {
    const cloneGrandOption = cloneDeep(data);
    const total = [];
    const beforeTotal = [];
    const totalUnits = [];
    if (checkArray(cloneGrandOption.templateJsonSchema)) {
      cloneGrandOption.templateJsonSchema.map((ele) => {
        if (ele?.type === 'Ratio_Pack') {
          const eleTotal = [];
          const eleBeforeTotal = [];
          const eleTotalUnits = [];
          if (ele?.sigularPackedUnits) {
            ele?.sigularPackedUnits.forEach((element) => {
              total.push(parseFloat(hasNumberValue(element?.totalPriceAfterDisc)));
              beforeTotal.push(parseFloat(hasNumberValue(element?.totalPriceBeforeDisc)));
              totalUnits.push(parseFloat(hasNumberValue(element?.totalQuantity)));
              eleTotal.push(parseFloat(hasNumberValue(element?.totalPriceAfterDisc)));
              eleBeforeTotal.push(parseFloat(hasNumberValue(element?.totalPriceBeforeDisc)));
              eleTotalUnits.push(parseFloat(hasNumberValue(element?.totalQuantity)));
            });
          }
          if (ele?.multiplePacks) {
            ele?.multiplePacks.forEach((object) => {
              total.push(parseFloat(hasNumberValue(object?.totalPriceAfterDisc)));
              beforeTotal.push(parseFloat(hasNumberValue(object?.totalPriceBeforeDisc)));
              totalUnits.push(parseFloat(hasNumberValue(object?.totalUnits)));
              eleTotal.push(parseFloat(hasNumberValue(object?.totalPriceAfterDisc)));
              eleBeforeTotal.push(parseFloat(hasNumberValue(object?.totalPriceBeforeDisc)));
              eleTotalUnits.push(parseFloat(hasNumberValue(object?.totalUnits)));
            });
          }
          if (ele?.multipleTotalPacks) {
            ele?.multipleTotalPacks.forEach((obj) => {
              total.push(parseFloat(hasNumberValue(obj?.totalPriceAfterDisc)));
              beforeTotal.push(parseFloat(hasNumberValue(obj?.totalPriceBeforeDisc)));
              totalUnits.push(parseFloat(hasNumberValue(obj?.totalUnits)));
              eleTotal.push(parseFloat(hasNumberValue(obj?.totalPriceAfterDisc)));
              eleBeforeTotal.push(parseFloat(hasNumberValue(obj?.totalPriceBeforeDisc)));
              eleTotalUnits.push(parseFloat(hasNumberValue(obj?.totalUnits)));
            });
          }
          if (ele?.ratioPacks) {
            ele?.ratioPacks.forEach((obj) => {
              totalUnits.push(parseFloat(obj?.totalDestPacks) * parseFloat(obj?.totalPackRatio));
              eleTotalUnits.push(parseFloat(obj?.totalDestPacks) * parseFloat(obj?.totalPackRatio));
              total.push(parseFloat(obj?.totalPriceAfterDisc));
              beforeTotal.push(
                parseFloat(obj?.totalPriceBeforeDisc),
                // parseFloat(obj?.totalDestPacks) *
                // parseFloat(obj?.totalPackRatio)
              );
              eleTotal.push(obj?.totalPriceAfterDisc ? parseFloat(obj?.totalPriceAfterDisc) : 0);
              eleBeforeTotal.push(parseFloat(obj?.totalPriceBeforeDisc));
            });
            ele.totalAfterDisc = sum(eleTotal.map((totalEle) => parseFloat(hasNumberValue(totalEle))));
            ele.totalBeforeDisc = sum(eleBeforeTotal.map((totalbefore) => parseFloat(hasNumberValue(totalbefore))));
            ele.grandTotalUnit = sum(eleTotalUnits.map((totUnits) => parseFloat(hasNumberValue(totUnits))));
          }
          cloneGrandOption.totalAfterDiscount = sum(total.map((totalEle) => parseFloat(hasNumberValue(totalEle))));
          cloneGrandOption.totalBeforeDiscount = sum(beforeTotal.map((bTotal) => parseFloat(hasNumberValue(bTotal))));
          cloneGrandOption.totalRatioQuantity = sum(totalUnits.map((totUnit) => parseFloat(hasNumberValue(totUnit))));
        }
        return ele;
      });
    }
    return cloneGrandOption;
  };
  return { calculateGrandTotal };
}
